<template>
  <div id="description">
    <!-- web -->
    <div class="web d-none d-mb-block">
      <div class="title">
        <p class="m-0">系教育目標與能力綱目</p>
      </div>

      <div class="catalog">
        <el-row class="catalog__bor" v-for="(item, index) in educationList" :key="'EL_' + index">
          <el-col :span="4">
            <div class="catalog__darkBG">
              <div class="h-100 p-20 d-flex align-items-center justify-content-around flex-column">
                <p v-for="(education, idx) in item.educationSystem" :key="idx" class="m-0 py-10">{{ education }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="pl-50 catalog__content">
              <ul class="m-0">
                <li v-for="(content, index) in item.data" :key="'LS__' + index">
                  {{ content }}
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="rules">
        <div class="w-100 d-flex justify-content-between">
          <!-- 學制 -->
          <div class="w-100">
            <div class="p-20 d-flex align-items-center flex-column">
              <div class="w-100 mb-45">
                <p class="m-0 rules__title">Download</p>
              </div>
              <div class="w-100">
                <div class="w-100 downloadCard d-flex flex-column">
                  <div class="px-80 py-15 downloadCard__download d-flex align-items-center">
                    <p class="m-0">五種學制地圖</p>
                    <span v-for="item in getEduMap" :key="item.id">
                      <el-tooltip effect="light" content="檔案下載" placement="bottom">
                        <a class="d-flex align-items-center justify-content-center ml-20" :href="item.fileLink"
                          :download="item.fileName" target="_blank">
                          <img src="@/assets/images/icon/pdf_icon.png" alt="" />
                        </a>
                      </el-tooltip>
                    </span>
                  </div>
                  <div class="px-80 py-15 downloadCard__title">
                    <a href="https://aca.ntua.edu.tw/article.aspx?ca=211&id=140" target="_blank"> 各年度課程科目學分表查詢 </a>
                  </div>
                  <div class="w-100 downloadCard__content">
                    <div class="py-20 px-30">
                      <div class="d-flex align-items-center justify-content-center mt-20 mb-30"
                        v-for="(item, key) in downloadList" :key="'DL_' + key">
                        <div
                          class="w-100 py-20 d-flex align-items-center justify-content-center downloadCard__content-list pos-relative">
                          <a class="px-10" :href="items.fileLink" :download="items.fileLink" target="_blank"
                            v-for="items in item" :key="items.id">
                            {{ items.fileName }}
                          </a>
                          <div
                            class="downloadCard__content-blackTag p-10 d-flex align-items-center justify-content-center pos-absolute l-0 t-0">
                            {{ key }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="triangle">
        <div class="w-100 d-flex align-items-center justify-content-between pb-80 mb-80">
          <div class="w-100 d-flex align-items-center flex-column ml-25 mt-150" v-for="(item, index) in depIntroduce"
            :key="'DI_' + index">
            <div class="w-100 text-left">
              <p class="triangle__title d-flex m-0">{{ item.titleName }}</p>
            </div>
            <div class="w-100 triangle__content d-flex flex-column" v-for="(items, index) in item.options"
              :key="'OP_' + index">
              <p class="m-0">{{ items.context }}</p>
            </div>
          </div>

          <div class="w-100">
            <div class="w-100 d-flex align-items-center justify-content-center flex-column">
              <div class="mt-20">
                <img src="@/assets/images/triangle/triangle-top.png" alt="" v-if="!triangleBlock.top" />
                <div class="pos-relative" v-else>
                  <img src="@/assets/images/triangle/triangle-top_hover.png" alt="" />
                  <div class="pos-absolute t-0 mt-130" style="margin-left: -18.4rem">
                    <img src="@/assets/images/triangle/triangle-topText_hover.png" alt="" />
                  </div>
                </div>
              </div>

              <div class="mt-66">
                <img src="@/assets/images/triangle/triangle-middle.png" alt="" v-if="!triangleBlock.middle" />
                <div class="pos-relative" v-else>
                  <img src="@/assets/images/triangle/triangle-middle_hover.png" alt="" />
                  <div class="pos-absolute t-0 mt-60" style="margin-left: -19.6rem">
                    <img src="@/assets/images/triangle/triangle-middleText_hover.png" alt="" />
                  </div>
                </div>
              </div>

              <div class="mt-44">
                <img src="@/assets/images/triangle/triangle-bottom.png" alt="" v-if="!triangleBlock.bottom" />
                <div class="pos-relative" v-else>
                  <img src="@/assets/images/triangle/triangle-bottom_hover.png" alt="" />
                  <div class="pos-absolute t-0 mt-45" style="margin-left: -57.3rem">
                    <img src="@/assets/images/triangle/triangle-bottomText_hover.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- phone -->
    <div class="phone d-block d-mb-none">
      <div class="courseCard bg-white">
        <div class="p-20 courseCard__title">
          <p class="m-0">系教育目標與能力綱目</p>
        </div>
        <div class="px-40 py-20">
          <el-row>
            <el-col class="d-flex align-items-center justify-content-center" :span="12"
              v-for="(item, idx) in educationList" :key="idx">
              <div class="courseCard__content d-flex align-items-center justify-content-center flex-column my-10"
                @click="openGoal(item.data)">
                <p v-for="(education, $idx) in item.educationSystem" :key="$idx" class="m-0">{{ education }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="courseDownload pt-50">
        <div class="px-30">
          <div class="w-100 courseDownload__title">
            <p class="m-0">Download</p>
          </div>
          <div class="w-100 courseDownload__content mt-15">
            <div class="courseDownload__content-download w-100">
              <div class="px-20 py-10 d-flex align-items-center justify-content-center flex-row">
                <div class="w-100 text-center">
                  <p class="m-0">五種學制地圖</p>
                </div>
                <img src="@/assets/images/icon/pdf_icon.png" alt="" height="32px" />
              </div>
            </div>
            <div class="courseDownload__content-header w-100 text-center">
              <div class="px-20 py-10">
                <p class="m-0">各年度課程科目學分查詢</p>
              </div>
            </div>
            <div class="courseDownload__content-body w-100">
              <div class="p-30">
                <div class="w-100 subjectCard d-flex align-items-center justify-content-center py-10 pos-relative"
                  v-for="(item, key) in downloadList" :key="'DLL__' + key">
                  <a class="px-5" :href="items.fileLink" :download="items.fileLink" target="_blank"
                    v-for="items in item" :key="items.id">
                    {{ items.fileName }}
                  </a>
                  <span class="subjectCard__tag p-6 pos-absolute t-0 l-0">
                    <p class="m-0">{{ key }}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="courseDevelope pt-60">
        <div class="px-30" v-for="(item, index3) in depIntroduce" :key="index3">
          <div class="w-100 courseDevelope__title mb-5">
            <p class="m-0">{{ item.titleName }}</p>
          </div>
          <div class="w-100 courseDevelope__content d-flex align-items-center justify-content-center"
            v-for="(items, index4) in item.options" :key="index4">
            <p class="m-0 my-5">{{ items.context }}</p>
          </div>
        </div>
      </div>
      <div class="courseTriangle py-40">
        <div class="w-100 text-center">
          <div class="w-100 pos-relative">
            <img src="@/assets/images/triangle/triangle_phone-top.png" alt="" />
            <div class="w-100 text-center pos-absolute t-0 mt-45">
              <p class="m-0">文化創意產業</p>
            </div>
          </div>
          <div class="w-100 mt-20 pos-relative">
            <img src="@/assets/images/triangle/triangle_phone-middle.png" alt="" />
            <div class="w-100 text-center pos-absolute t-0 mt-20">
              <p class="m-0">產品設計</p>
              <p class="m-0">理性邏輯＋感性直覺</p>
            </div>
          </div>
          <div class="w-100 mt-10 pos-relative">
            <img src="@/assets/images/triangle/triangle_phone-bottom.png" alt="" />
            <div class="w-100 text-center pos-absolute t-0">
              <p class="m-0">工藝創作</p>
              <p class="m-0">材質本位＋製作精神</p>
              <p class="m-0">藝術視野</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal -->
    <div class="modal" v-if="showGoal">
      <div class="modal__content">
        <div class="w-100 d-flex align-items-center justify-content-center">
          <div class="pos-relative w-100 d-flex justify-content-center">
            <div class="w-100 goalCard">
              <div class="py-70 px-20">
                <div class="pl-30 goalCard__content">
                  <ul class="m-0 pl-0">
                    <li class="mb-40" v-for="(content, index) in goalContents" :key="'LS__' + index">
                      {{ content }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="pos-absolute t-0 r-0">
              <div class="close d-flex align-items-center justify-content-center cur-pointer mt-20 mr-20"
                @click="showGoal = false">
                <img src="@/assets/images/icon/cancel.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listQuery: {
        TypeId: "",
        page: 1,
        limit: 100,
        key: undefined,
      },
      topFlag: true,
      scrollTop: "",
      triangleBlock: {
        top: false,
        middle: false,
        bottom: false,
      },
      ruleList: [
        {
          imgURL: require("@/assets/images/icon/A.png"),
          context: "「三元教育目標」作為課程規劃的思考核心，亦即：產品設計、工藝創作和文化創意產業。",
        },
        {
          imgURL: require("@/assets/images/icon/B.png"),
          context: "以美學涵養為底蘊、以工藝媒材為基礎、以設計思維為主軸、以工作室教學為特色、以藝術行銷與管理為策略，形塑一個理論與實務並重的教學體系。",
        },
        {
          imgURL: require("@/assets/images/icon/C.png"),
          context: "規劃各式專業選修學程，落實分科教育，以建構學生「七項核心能力」為目標。",
        },
      ],
      educationList: [],
      downloadList: [],
      depIntroduce: [
        {
          titleName: "系所發展",
          options: [
            {
              context: "「工不可沒•藝不可失」的工藝實踐基礎",
            },
            {
              context: "「工藝創作」與「量產設計」的有機融合",
            },
            {
              context: " 配合國家政策發展文化創意產業",
            },
            {
              context: " 強化國際工藝設計文化之交流",
            },
          ],
        },
      ],
      getEduMap: [],
      // modal
      showGoal: false,
      goalContents: [],
    };
  },
  watch: {
    scrollTop() {
      if (this.scrollTop > 3300) {
        if (this.topFlag) {
          this.triangleBlock.top = true;
          this.topFlag = false;
        }
      } else {
        if (!this.topFlag) {
          this.triangleBlock.top = false;
          this.topFlag = true;
        }
      }
      if (this.scrollTop > 3600) {
        this.triangleBlock.middle = true;
      } else {
        this.triangleBlock.middle = false;
      }
      if (this.scrollTop > 3900) {
        this.triangleBlock.bottom = true;
      } else {
        this.triangleBlock.bottom = false;
      }
    },
  },
  mounted() {
    this.$store.commit("SETLOADING", true);
    this.getEducationList();
    this.getFilesList();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    openGoal(contents) {
      this.goalContents = contents;
      this.showGoal = true;
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    /** 獲取 系教育目標與能力綱目 列表 */
    async getEducationList() {
      const { data: { data = [] } } = await this.$api.getEducationCatalogsList({ page: 1, limit: 50 });
      this.educationList = data?.map((i) => {
        return {
          educationSystem: i.educationSystem.split(' '),
          data: i.data,
          sort: i.sort
        }
      });
    },
    /** 獲取 學制地圖檔案 列表 */
    getFilesList() {
      this.$api.singleFile(this.listQuery).then((res) => {
        let mapdata = res.data.data.filter((data) => data.typeId == "SYS_SINGLEFILE_MAP");
        this.getEduMap = mapdata ? mapdata : [];
        let newArr = res.data.data.filter((data) => data.typeId !== "SYS_SINGLEFILE_MAP");
        let obj = {};
        newArr.map((i) => {
          Object.keys(obj).includes(i.typeName) ? (obj = obj) : (obj[i.typeName] = []);
          obj[i.typeName].push(i);
        });
        this.downloadList = obj;
        this.$store.commit("SETLOADING", false);
      });
    },
  },
};
</script>

<style lang="scss">
#description {
  .web {
    margin-left: 0 !important;
    padding-top: 0 !important;

    .title {
      padding: 30px 200px 0px 200px;
      font-size: 48px;
      line-height: 56px;
      color: #ceb87f;
    }

    .catalog {
      margin: 0px 200px;

      &__bor {
        padding: 60px 0px;
        border-bottom: 2px solid #c4c4c4;

        &:last-child {
          border-bottom: none;
        }
      }

      &__darkBG {
        width: 200px;
        height: 200px;
        background: #2d2d2d;
        color: #ceb87f;
        line-height: 160%;
        letter-spacing: 0.12em;

        p {
          font-size: 24px;
        }

        strong {
          font-size: 36px;
        }
      }

      &__content {
        ul {
          list-style: square inside url("../../assets/images/icon/squareDot.png");

          li {
            margin-top: 25px;
            font-size: 24px;
            font-weight: bold;
            line-height: 160%;
            letter-spacing: 0.2em;
            color: #596164;

            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
    }

    .rules {
      width: 100%;

      &__title {
        font-size: 24px;
        line-height: 28px;
        color: #ceb87f;
      }

      &__Card {
        height: 190px;
        margin-left: 80px;
        background: #c4c4c4;
        border-radius: 20px;
        font-size: 20px;
        line-height: 160%;
        letter-spacing: 0.15em;
        color: #596164;
      }

      .downloadCard {
        height: 690px;

        &__download {
          font-size: 24px;
          line-height: 160%;
          letter-spacing: 0.37em;
          color: #ceb87f;
          background: #2d2d2d;
          border-bottom: 1px solid #ffffff;
        }

        &__title {
          background: #2d2d2d;

          a {
            font-size: 24px;
            line-height: 160%;
            letter-spacing: 0.37em;
            color: #ceb87f;

            &:hover {
              font-weight: bold;
            }
          }
        }

        &__content {
          position: relative;
          background: #c4c4c4;
          height: 553px;
          overflow-y: auto;

          &-blackTag {
            white-space: nowrap;
            transform: translateY(-1rem);
            margin-left: -0.5rem;
            background: #2d2d2d;
            font-size: 20px;
            line-height: 160%;
            letter-spacing: 0.3em;
            color: #ceb87f;
          }

          &-list {
            background: #ffffff;

            a {
              font-size: 18px;
              letter-spacing: 0.37em;
              color: #596164;

              &:hover {
                color: #ceb87f;
                font-weight: bold;
              }
            }
          }
        }
      }
    }

    .triangle {
      &__title {
        width: 150px;
        font-size: 72px;
        line-height: 84px;
        color: #ceb87f;
      }

      &__content {
        margin-top: 10px;
        font-size: 18px;
        font-weight: bold;
        line-height: 160%;
        letter-spacing: 0.05em;
        color: #40172d;

        @media (min-width: 1600px) {
          font-size: 24px;
        }
      }
    }
  }

  .phone {
    .courseCard {
      &__title {
        font-size: 24px;
        line-height: 28px;
        color: #ceb87f;
      }

      &__content {
        background: #2d2d2d;
        width: 120px;
        height: 120px;

        p {
          font-size: 12px;
          line-height: 160%;
          letter-spacing: 0.37em;
          color: #ceb87f;
        }

        strong {
          font-size: 18px;
          line-height: 160%;
          letter-spacing: 0.12em;
          color: #ceb87f;
        }
      }
    }

    .coursePlan {
      background: #ffffff;

      &__title {
        font-size: 24px;
        line-height: 28px;
        color: #ceb87f;
      }

      &__content {
        &-card {
          background: #c4c4c4;
          border-radius: 20px;

          p {
            font-size: 14px;
            line-height: 160%;
            letter-spacing: 0.37em;
            color: #596164;
          }
        }
      }
    }

    .courseDownload {
      background: #ffffff;

      &__title {
        font-size: 24px;
        line-height: 28px;
        color: #ceb87f;
      }

      &__content {
        &-download {
          background: #2d2d2d;
          border-bottom: 1px solid #ffffff;
          font-size: 18px;
          line-height: 160%;
          letter-spacing: 0.37em;
          color: #ceb87f;
        }

        &-header {
          background: #2d2d2d;
          font-size: 18px;
          line-height: 160%;
          letter-spacing: 0.37em;
          color: #ceb87f;
        }

        &-body {
          background: #c4c4c4;

          .subjectCard {
            background: #ffffff;
            font-size: 16px;
            line-height: 160%;
            letter-spacing: 0.37em;
            color: #596164;
            margin-bottom: 50px;

            &:last-child {
              margin-bottom: 0px;
            }

            &__tag {
              background: #2d2d2d;
              margin-left: -1rem;
              margin-top: -1.3rem;

              p {
                font-size: 14px;
                line-height: 160%;
                letter-spacing: 0.37em;
                color: #ceb87f;
              }
            }
          }
        }
      }
    }

    .courseDevelope {
      background: #ffffff;

      &__title {
        p {
          width: 50px;
          font-size: 24px;
          line-height: 28px;
          color: #ceb87f;
        }
      }

      &__content {
        font-size: 14px;
        line-height: 160%;
        letter-spacing: 0.25em;
        color: #40172d;
      }
    }

    .courseTriangle {
      background: #ffffff;

      p {
        font-size: 14px;
        font-weight: bold;
        line-height: 180%;
        letter-spacing: 0.25em;
        color: #40172d;
      }
    }
  }

  // modal
  .goalCard {
    background: #52505a;
    backdrop-filter: blur(4px);
    border-radius: 40px;

    &__content {
      ul {
        list-style: square inside url("../../assets/images/icon/squareDot.png");
      }

      li {
        font-size: 14px;
        line-height: 160%;
        letter-spacing: 0.37em;
        color: #ffffff;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  ::-webkit-scrollbar-track-piece {
    //滾動條凹槽的顏色，還可以設定邊框屬性
    background-color: #f8f8f8;
  }

  ::-webkit-scrollbar {
    //滾動條的寬度
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-thumb {
    //滾動條的設定
    background-color: #dddddd;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
  }
}
</style>